<template>
  <div class="user-avator-dropdown">
    <!-- <Button type="text" style="color:#2db7f5" size="small" @click="qiyeInfo()">{{userBussice}}</Button> -->
    <!-- <Button type="text" size="default" @click="goPage('Favorite')">收藏夹</Button> -->
    <!-- <Button type="text" size="default" @click="goPage('WrongTopic')" style="margin-right:4px">错题本</Button> -->
    <!-- <Button type="text" size="default" @click="goPage('HistoricalRecord')">积分和订单</Button>
    <Button type="text" size="default" @click="goPage('BusinessManagement')">个人空间</Button> -->
    <!-- <Avatar :src="imgAvator" alt=""/> -->
    <!-- <Dropdown @on-click="handleClick">
      <Badge :dot="!!messageUnreadCount">
        <span v-if="userAvator" class="userAtar" style="margin-left:.8vw;">{{userAvator}}</span>
      </Badge>
      <Icon :size="18" type="md-arrow-dropdown"></Icon>
      <DropdownMenu slot="list">
        <DropdownItem name="message">
          消息中心 
          <Badge style="margin-left: 10px" :count="messageUnreadCount"></Badge>
        </DropdownItem>
        <DropdownItem name="set">帮助中心</DropdownItem>
        <DropdownItem name="logout">退出登录</DropdownItem>
      </DropdownMenu>
    </Dropdown> -->
  </div>
</template>

<script>
import "./user.less";
import { mapMutations } from "vuex";
export default {
  name: "User",
  props: {
    userAvator: {
      type: String,
      default: ""
    },
    userBussice: {
      type: String,
      default: ""
    },
    imgAvator:{
      type: String,
      default: ""
    },
    messageUnreadCount: {
      type: Number,
      default: 0
    }
  },
  methods: {
    ...mapMutations(["setBuisnessToken","setAuthList"]),
    logout() {
      this.setBuisnessToken('');
      // this.setUserInfo({})
      this.setAuthList([]);
      // this.$cookies.remove('ZONG_TOKEN')
      sessionStorage.removeItem("userInfo")
      localStorage.removeItem("tagNaveList");
      this.$router.replace({ name: "Login" });
      // this.$axios.get("/admin/login/logout").then(res => {
      //   if (res.code == 1) {
      //     this.$Message.error(res.msg);
      //   } else {
      //     this.setBuisnessToken('');
      //     this.setAuthList([]);
      //     this.$router.replace({ name: "Login" });
      //   }
      // });
    },
    goPage(name){
      this.$router.replace({name:name})
    },
    qiyeInfo(){
      this.$router.push({
        name: "BusinessManagement"
      });
    },
    message() {
      // this.$router.push({
      //   name: "message_page"
      // });
    },
    handleClick(name) {
      switch (name) {
        case "logout":
          this.logout();
          break;
        case "message":
          this.message();
          break;
        case "set":
          this.$router.replace({ name: "StatisticalLearning" });
          break;
          case "Favorite":
          this.$router.replace({ name: "Favorite" });
          break;
          case "HistoricalRecord":
          this.$router.replace({ name: "HistoricalRecord" });
          break;
      }
    }
  }
};
</script>
<style  scoped>
.userAtar{
  /* width:2rem;
  height:2rem; */
  font-size:.2rem;
  /* background: #bbb; */
  /* margin-left:8px; */
  color:#999;
  /* padding:.5rem .1rem .4rem; */
  /* border-radius: 20%; */
}
</style>